import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput, MDBIcon, MDBFormInline  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip ,PageHeader, Avatar  } from 'antd';
import Swal from 'sweetalert2'
import { URL,api } from '../../api';

export default class Modaladdadmintype extends Component {
    constructor(props) {
        super(props);
                this.state = {
                modal: false,

                send_id :'1', //ผู้ลงทะเบียน
                send_type : '', //ประเภท

                name_admin : '', //ผู้นำเสนอ
                username_admin : '', //ผู้นำเสนอ
                password_admin : '', //ผู้นำเสนอ
               
                presentype:[],
                presentypeid:'',
                }

   
              


           
                this.toggle = this.toggle.bind(this);
                this.handleSubmit = this.handleSubmit.bind(this);

               
                this.handleChangesend_name = this.handleChangesend_name.bind(this);
                this.handleChangesend_username = this.handleChangesend_username.bind(this);
                this.handleChangesend_password = this.handleChangesend_password.bind(this);
                this.handleChangesend_affiliation = this.handleChangesend_affiliation.bind(this);
                this.handleChangesend_expertise = this.handleChangesend_expertise.bind(this);
                this.handleChangesend_tel = this.handleChangesend_tel.bind(this);
                this.handleChangesend_presentype = this.handleChangesend_presentype.bind(this);


             
}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
 // this.props.selectatf();
}


presentypelist(){
    // console.log(u)
   //  this.setState({province:u.value, provincename:u.label})
     setTimeout(() => {
         //จังหวัด
         api.get('registercon/selecttpresentationtype')
         // Axios.get('http://localhost/phpapi/selectamphures.php?PROVINCE_ID='+u.value)
         .then(res => {
       //    console.log(res);
         //  this.setState({ bankname: res.data, loading: false })
         const data = res.data
         const optionsam = data.map(a => ({
             "value" : a.presentype_id,
             "label" : a.presentype_name
           }))
           this.setState({ presentype: optionsam})
         }) 
       }, 0);
    }




 componentDidMount() {
       const { iduser } = this.props.iduser
    //   console.log(id_send);
       this.setState({ iduser:this.props.iduser})
       this.presentypelist();
    //   setTimeout(() => {
    //     //ภายใน
    //      Axios.get('https://conference.kpru.ac.th/PHPAPI/selectExpert.php')
    //     .then(res => {
    //       console.log(res);
    //     //  this.setState({ bankname: res.data, loading: false })
    //       this.setState({ Expert: res.data})
    //     }) 

    //   }, 0);

  }

//   getExpert() {
//     setTimeout(() => {
//       //ภายใน
//        Axios.get('https://conference.kpru.ac.th/PHPAPI/selectExpert.php')
//       .then(res => {
//         console.log(res);
//       //  this.setState({ bankname: res.data, loading: false })
//         this.setState({ Expert: res.data})
//       }) 
//     }, 0);

// }


handleChangesend_name(event) {    this.setState({name_admin: event.target.value});  }
handleChangesend_username(event) {    this.setState({username_admin: event.target.value});  }
handleChangesend_password(event) {    this.setState({password_admin: event.target.value});  }
handleChangesend_affiliation(event) {    this.setState({affiliation_expert: event.target.value});  }
handleChangesend_expertise(event) {    this.setState({expertise_expert: event.target.value});  }
handleChangesend_tel(event) {    this.setState({tel_expert: event.target.value});  }

handleChangesend_presentype(event) {  
    console.log(event)
      this.setState({presentypeid: event});  
    }


  handleSubmit() {
    // alert('A name was submitted: ' + this.state.value);
   setTimeout(() => {

    const date = new Date();
    const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
    const dates = day+"-"+month+"-"+year ;

      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
    //  datafrm.append("send_id", this.props.iduser);
      datafrm.append("name_admin", this.state.name_admin);
      datafrm.append("username_admin", this.state.username_admin);
      datafrm.append("password_admin", this.state.password_admin);
      datafrm.append("status_admin", "admintype");
      datafrm.append("presentype_id", this.state.presentypeid);
   

     //  datafrm.append("agree_type", this.state.radio);
     //  datafrm.append("send_uploadeword12", this.state.send_uploadeword12);
     //  datafrm.append("send_uploadepdf12", this.state.send_uploadepdf12);
     // datafrm.append("send_date1", dates);

     //  datafrm.append("send_statuspay", this.state.send_statuspay);
     //  datafrm.append("stapat", this.state.stapat);

    api.post("registercon/Insertadmintype",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
    }
   })

   .then(res => {
    console.warn(res);
     console.log("response: ", res)
     if (res.data.length !== 0) {
      // this.showitem = true;
       console.log(res)
       console.log(res.data.length) 
    }else{
     // window.location.href = '/'
    }


    if (res.data = '200') {
     // message.success("อัพโหลไฟล์สำเร็จ")
    //  this.setState({ id_send: ""})
     // window.location.href = '/adminfaculty'
     Swal.fire({
      title: 'เพิ่มข้อมูลผู้ดูแลระบบสำเร็จ',
      text: "Administrator information added successfully",
      icon: 'success',
      showCancelButton: false,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'ตกลง'
    }).then((result) => {
      if (result.isConfirmed) {
        // Swal.fire(
        //   'Deleted!',
        //   'Your file has been deleted.',
        //   'success'
        // )
        this.props.list();
        this.toggle()
      }
    })
    
    }else{
      message.error("อัพโหลไฟล์ไม่สำเร็จ!")
    }

  })



}, 2000);

//window.location.href = '/adminfaculty'
//this.props.updateat();
//this.getExpert()

  }

  

    render() {
        
        //   console.log(this.state.send_type)
        //   console.log(this.state.major_precent)
        //   console.log(this.state.name_present)
        //   console.log(this.state.send_name)
        //   console.log(this.state.send_uploadeword1)
        //   console.log(this.state.send_uploadepdf1)
        //   console.log(this.state.radio)


        return (
          
            <MDBContainer className='text-left'>
           <div className='text-center'><MDBBtn color="deep-purple" onClick={this.toggle}><MDBIcon icon="plus-square" />  เพิ่มข้อมูลผู้ดูแลระบบ</MDBBtn></div> 

            <MDBModal isOpen={this.state.modal} toggle={this.toggle} size="lg">
              <MDBModalHeader toggle={this.toggle}> <Avatar src="https://cdn-icons-png.flaticon.com/512/5399/5399692.png" /> เพิ่มข้อมูลผู้ดูแลระบบ</MDBModalHeader>
              <MDBModalBody>
              <div>

           
                    

                            <div className="mb-2">
                           <label className="black-text"><strong>ชื่อผู้ดูแลระบบ</strong></label>
                           <input className="form-control" onChange={this.handleChangesend_name} name="name"
                                    value={this.state.name_expert} placeholder="กรุณาระบุผู้ดูแลระบบ" required />
                            </div>
                  

                           <div className="mb-2">
                           <label className="black-text"><strong>Username</strong></label>
                           <input className="form-control" onChange={this.handleChangesend_username} name="username"
                                    value={this.state.username_expert} placeholder="กรุณาระบุ Username" required />
                            </div>

                            <div className="mb-2">
                           <label className="black-text"><strong>Password</strong></label>
                           <input className="form-control" onChange={this.handleChangesend_password} name="password"
                                    value={this.state.password_expert} placeholder="กรุณาระบุ Password" required />
                            </div>

                            <div className="mb-2">
                            <label className="black-text">ประเภทที่ดูแล</label>
                            <Select placeholder="กรุณาระบุ ประเภทที่ดูแล"  className="browser-default custom-select " options={this.state.presentype}  onChange={this.handleChangesend_presentype.bind(this)} required/><br/>
                            </div>

                            




                 
              </div>
              
              </MDBModalBody>
              <MDBModalFooter>
                 <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn>
                <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
               
              </MDBModalFooter>
            </MDBModal>
          </MDBContainer>
          
        )
    }
}
